[
    {
        "key": "title",
        "description": "General title of products",
        "fr": "Gants de boxe",
        "en": "Boxing gloves",
        "es": "Guantes de Boxeo",
        "de": "Boxhandschuhe",
        "it": "Guantoni da boxe"
    },
    {
        "key": "subtitle",
        "description": "Name of the product",
        "fr": "Venum Giant 3.0",
        "en": "Venum Giant 3.0",
        "es": "Venum Giant 3.0",
        "de": "Venum Giant 3.0",
        "it": "Venum Giant 3.0 Pro"
    },
    {
        "key": "Fabric_Impact",
        "en": "Cooucuo Test"
    },
    {
        "key": "Fabric_Impact_Zone",
        "description": "attribute of categories title",
        "fr": "Zone d'impact",
        "en": "Impact Zone",
        "es": "Zona de impacto",
        "de": "Aufprallzone",
        "it": "Area di impatto",
        "e": "สีหนังชิ้นหลังมือ"
    },
    {
        "key": "Fabric_Thumb",
        "description": "attribute of categories title",
        "fr": "Pouce",
        "en": "Thumb",
        "es": "Pulgar",
        "de": "Daumen",
        "it": "Pollice",
        "e": "สีหนังนิ้วชิ้นหลังมือ"
    },
    {
        "key": "Fabric_Wrist",
        "description": "attribute of categories title",
        "fr": "Poignet",
        "en": "Wrist",
        "es": "Muñeca",
        "de": "Handgelenk",
        "it": "Polso",
        "e": ""
    },
    {
        "key": "Velcro_Strap",
        "description": "attribute of categories title",
        "fr": "Bande Velcro",
        "en": "Velcro Strap",
        "es": "Correa de Velcro",
        "de": "Klettverschluss",
        "it": "Fascia in velcro",
        "e": "สีหน้งสายเวลโก้"
    },
    {
        "key": "Fabric_Piping",
        "description": "attribute of categories title",
        "fr": "Piping",
        "en": "Piping",
        "es": "Conducto",
        "de": "Kordel",
        "it": "Bordo",
        "e": "สีหนังกุ๊น+หนวด"
    },
    {
        "key": "Fabric_Inner_thumb",
        "description": "attribute of categories title",
        "fr": "Intérieur du pouce",
        "en": "Inner thumb",
        "es": "Interior del pulgar",
        "de": "Innerer Daumenbereich",
        "it": "Pollice attaccato",
        "e": "สีหนังนิ้วชิ้นใน"
    },
    {
        "key": "Fabric_Right_Palm",
        "description": "attribute of categories title",
        "fr": "Paume Droite",
        "en": "Right Palm",
        "es": "Palma Derecha",
        "de": "Rechte Handfläche",
        "it": "Palmo destro",
        "e": "สีหนังชิ้นฝ่ามือด้านนิ้วโป้ง"
    },
    {
        "key": "Fabric_Left_Palm",
        "description": "attribute of categories title",
        "fr": "Paume Gauche",
        "en": "Left Palm",
        "es": "Palma Izquierda",
        "de": "Linke Handfläche",
        "it": "Palmo sinistro",
        "e": "สีหนังชิ้นฝ่ามือด้านนิ้วก้อย"
    },
    {
        "key": "Fabric_Grip_Bar",
        "description": "attribute of categories title",
        "fr": "Grip Bar",
        "en": "Grip bar",
        "es": "Mango",
        "de": "Hantelstange",
        "it": "Inserto antiscivolo",
        "e": "สีหนังปาล์ม"
    },
    {
        "key": "Fabric_Thumb_Connector",
        "description": "attribute of categories title",
        "fr": "Accroche pouce",
        "en": "Thumb connector",
        "es": "Dispositivo conector",
        "de": "Verbinder",
        "it": "Attaccatura del pollice",
        "e": "สีหนังง่ามนิ้ว"
    },
    {
        "key": "Fabric_Lace",
        "description": "attribute of categories title",
        "fr": "Lacet",
        "en": "Lace",
        "es": "Cordón",
        "de": "Schnürung",
        "it": "Lacci",
        "e": "สีเชือก"
    },
    {
        "key": "MASK_Impact_Zone",
        "description": "attribute of categories title",
        "fr": "Tête de serpent",
        "en": "Snake head",
        "es": "Cabeza de serpiente",
        "de": "Schlangenkopf",
        "it": "Testa di serpente",
        "e": "สีลายหัวงู"
    },
    {
        "key": "MASK_Small_Venum",
        "description": "attribute of categories title",
        "fr": "Petit Venum",
        "en": "Small Venum",
        "es": "Pequeño Venum",
        "de": "Venum klein",
        "it": "Venum piccolo",
        "e": "สีโลโก้ VENUM เล็ก"
    },
    {
        "key": "label_background_color",
        "description": "attribute of categories title",
        "fr": "Etiquette",
        "en": "Label background",
        "es": "Antecedentes de la marca",
        "de": "Hintergrund Label",
        "it": "Sfondo etichetta",
        "e": "สีหนังป้ายข้อมือ"
    },
    {
        "key": "MASK_Label_Logos",
        "description": "attribute of categories title",
        "fr": "Logos sur étiquette",
        "en": "Label logos",
        "es": "Logotipos de la marca",
        "de": "Logos Label",
        "it": "Loghi etichetta",
        "e": "สีสกรีนป้ายข้อมือ"
    },
    {
        "key": "MASK_Thumb",
        "description": "attribute of categories title",
        "fr": "Venum Pouce",
        "en": "Venum Thumb",
        "es": "Dispositivo Venum",
        "de": "Venum Daumen",
        "it": "Pollice Venum",
        "e": "สีโลโก้นิ้ว"
    },
    {
        "key": "MASK_Velcro_Strap",
        "description": "attribute of categories title",
        "fr": "Logos Hand Made",
        "en": "Hand made logo",
        "es": "Logotipo Hecho a Mano",
        "de": "Hangefertigte Logos",
        "it": "Logo realizzato a mano",
        "e": "สีโลโก้ไทยแลนด์"
    },
    {
        "key": "palm_snake_head_color",
        "description": "attribute of categories title",
        "fr": "Logo Venum Custom",
        "en": "Venum Custom Logo",
        "es": "Logotipo Personalizado Venum",
        "de": "Personalisierte Venum-Logos",
        "it": "Logo personalizzato Venum",
        "e": "สีโลโก้ Custom"
    },
    {
        "key": "category.02.attribute.09.title",
        "description": "attribute of categories title",
        "fr": "Logo principal",
        "en": "Main Logo",
        "es": "Logotipo principal",
        "de": "Haupt-Logo",
        "it": "Logo principale",
        "e": "สีโลโก้หลัก"
    },
    {
        "key": "category.02.attribute.10.title",
        "description": "attribute of categories title",
        "fr": "Venum Impact",
        "en": "Not translated",
        "es": "Not translated",
        "de": "Not translated",
        "it": "Not translated",
        "e": ""
    },
    {
        "key": "Fabric_Pipings",
        "description": "attribute of categories title",
        "fr": "Pipings",
        "en": "Pipings",
        "es": "Conducto",
        "de": "Kordel",
        "it": "Bordo",
        "e": "สีหนังกุ๊น+หนวด"
    },
    {
        "key": "Fabric_Palm",
        "description": "attribute of categories title",
        "fr": "Paume",
        "en": "Palm",
        "es": "Palma",
        "de": "Handfläche",
        "it": "Palmo",
        "e": ""
    },
    {
        "key": "Stitching_Palm",
        "description": "attribute of categories title",
        "fr": "Coutures Paume",
        "en": "Stitching Palm",
        "es": "Puntadas Palma",
        "de": "Nähte Handfläche",
        "it": "Cuciture Palmo",
        "e": "สีด้ายชิ้นฝ่ามือ"
    },
    {
        "key": "Stitching_Wrist",
        "description": "attribute of categories title",
        "fr": "Coutures Poignet",
        "en": "Stitching Wrist",
        "es": "Puntadas Muñeca",
        "de": "Nähte Handgelenk",
        "it": "Cuciture Polso",
        "e": "สีด้ายข้อมือ"
    },
    {
        "key": "Stitching_Pipings",
        "description": "attribute of categories title",
        "fr": "Coutures Pipings",
        "en": "Stitching Pipings",
        "es": "Puntadas Conducto",
        "de": "Nähte Kordel",
        "it": "Cuciture Bordo",
        "e": "สีด้ายกุ๊น"
    }
]